export default __webpack_public_path__ + "static/media/LOGO-BLUETECH.d705e888.jpg";